import API_BASE_URL from './config';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function Notifications({ playerId }) {
  const [notifications, setNotifications] = useState([]);
  const [dogNames, setDogNames] = useState({});
  const [show, setShow] = useState(false);

  const notificationButtonImage = 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/e278b58f-e271-405b-8060-c4679e13d416/djfbfaq-78d41b3b-1724-479b-8e10-52bc12a7bfad.png?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcL2UyNzhiNThmLWUyNzEtNDA1Yi04MDYwLWM0Njc5ZTEzZDQxNlwvZGpmYmZhcS03OGQ0MWIzYi0xNzI0LTQ3OWItOGUxMC01MmJjMTJhN2JmYWQucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.iZuu-ZlALa995yUN4mBlqsQWEtMQH7WLuRRkIqh4ECQ';
  const frameImage = notificationButtonImage;

  useEffect(() => {
    const fetchNotifications = async () => {
      if (!playerId) return;
      try {
        const res = await fetch(`${API_BASE_URL}/notifications/${playerId}`, {
          headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        });
        if (!res.ok) throw new Error('Fetch failed');
        const data = await res.json();
        setNotifications(data);

        const dogIds = data.filter(n => n.dogId).map(n => n.dogId);
        const uniqueDogIds = [...new Set(dogIds)].filter(id => !dogNames[id]);
        if (uniqueDogIds.length > 0) {
          const dogRes = await Promise.all(
            uniqueDogIds.map(id =>
              fetch(`${API_BASE_URL}/dog/${id}`, {
                headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
              }).then(res => res.json())
            )
          );
          const newNames = Object.fromEntries(dogRes.map(dog => [dog.dogId, dog.registeredName]));
          setDogNames(prev => ({ ...prev, ...newNames }));
        }
      } catch (error) {
        console.error('Error fetching notifications:', error);
      }
    };

    fetchNotifications();
    const interval = setInterval(fetchNotifications, 10000);
    return () => clearInterval(interval);
  }, [playerId, dogNames]);

  const markAsRead = async (id) => {
    try {
      const res = await fetch(`${API_BASE_URL}/notification/${id}/read`, {
        method: 'PUT',
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      if (!res.ok) throw new Error('Update failed');
      setNotifications(notifications.map(n => n._id === id ? { ...n, read: true } : n));
    } catch (error) {
      console.error('Error marking as read:', error);
    }
  };

  const clearNotifications = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/notifications/${playerId}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      if (!res.ok) throw new Error('Clear failed');
      setNotifications([]);
    } catch (error) {
      console.error('Error clearing notifications:', error);
    }
  };

  const removeNotification = async (id) => {
    console.log('Attempting to remove notification with ID:', id); // Debug log
    try {
      const res = await fetch(`${API_BASE_URL}/notification/${id}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      console.log('Response status:', res.status); // Debug log
      if (!res.ok) {
        const errorText = await res.text();
        throw new Error(`Delete failed: ${errorText}`);
      }
      const data = await res.json();
      console.log('Response data:', data); // Debug log
      setNotifications(notifications.filter(n => n._id !== id));
    } catch (error) {
      console.error('Error removing notification:', error.message);
    }
  };

  const renderMessage = (notification) => {
    if (notification.dogId && dogNames[notification.dogId]) {
      const fullName = `${dogNames[notification.dogId]} (${notification.dogId})`;
      if (notification.message.includes('was approved and rolled')) {
        return (
          <span>
            Your entry for{' '}
            <Link to={`/dog/${notification.dogId}`} style={{ color: '#1E88E5', textDecoration: 'underline' }}>
              {fullName}
            </Link>{' '}
            was approved and rolled at iCON RNG!
          </span>
        );
      } else if (notification.message.includes('was entered into')) {
        return (
          <span>
            Your dog{' '}
            <Link to={`/dog/${notification.dogId}`} style={{ color: '#1E88E5', textDecoration: 'underline' }}>
              {fullName}
            </Link>{' '}
            {notification.message.split('Your dog ')[1]}
          </span>
        );
      } else if (notification.message.includes('was approved')) {
        return (
          <span>
            Your dog{' '}
            <Link to={`/dog/${notification.dogId}`} style={{ color: '#1E88E5', textDecoration: 'underline' }}>
              {fullName}
            </Link>{' '}
            was approved!
          </span>
        );
      }
    }
    return notification.message;
  };

  const unreadCount = notifications.filter(n => !n.read).length;

  return (
    <div style={{ position: 'relative', zIndex: 1000 }}>
      {/* Notification Button with Image and Green Bubble */}
      <div
        style={{
          position: 'relative',
          cursor: 'pointer',
          marginRight: '20px',
          width: '65px',
          height: '65px'
        }}
        onClick={() => setShow(!show)}
      >
        <img
          src={notificationButtonImage}
          alt="Notifications Envelope"
          style={{
            width: '65px',
            height: '65px',
            transition: 'transform 0.2s',
            filter: show ? 'brightness(0.9)' : 'none'
          }}
          onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
          onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
        />
        {unreadCount > 0 && (
          <span
            style={{
              position: 'absolute',
              top: '50%',
              right: '-7px',
              transform: 'translateY(-50%)',
              backgroundColor: '#4CAF50',
              color: 'white',
              borderRadius: '50%',
              width: '24px',
              height: '24px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '12px',
              fontWeight: 'bold',
              boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)'
            }}
          >
            {unreadCount}
          </span>
        )}
      </div>

      {/* Notifications Container with Framing Images */}
      <div
        style={{
          position: 'fixed',
          top: '150px',
          left: '50%',
          transform: show ? 'translateX(-50%) scaleY(1)' : 'translateX(-50%) scaleY(0)',
          width: '300px',
          maxHeight: '400px',
          backgroundColor: '#E6F0FA',
          borderRadius: '10px',
          boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
          transformOrigin: 'top',
          transition: 'transform 0.3s ease-in-out',
          zIndex: 1002
        }}
      >
        <img
          src={frameImage}
          alt="Left Frame"
          style={{
            position: 'absolute',
            left: '-50px',
            top: '50%',
            transform: 'translateY(-50%)',
            width: '40px',
            height: '40px',
            zIndex: 1000
          }}
        />
        <img
          src={frameImage}
          alt="Right Frame"
          style={{
            position: 'absolute',
            right: '-50px',
            top: '50%',
            transform: 'translateY(-50%)',
            width: '40px',
            height: '40px',
            zIndex: 1000
          }}
        />
        {show && (
          <div style={{ padding: '15px', maxHeight: '400px', overflowY: 'auto', textAlign: 'center' }}>
            {notifications.length > 0 ? (
              <>
                <button
                  onClick={clearNotifications}
                  style={{
                    background: '#EF5350',
                    color: 'white',
                    padding: '8px',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    marginBottom: '10px',
                    width: '100%',
                    fontWeight: 'bold',
                    transition: 'background-color 0.3s',
                    display: 'block',
                    marginLeft: 'auto',
                    marginRight: 'auto'
                  }}
                  onMouseOver={(e) => (e.target.style.backgroundColor = '#F44336')}
                  onMouseOut={(e) => (e.target.style.backgroundColor = '#EF5350')}
                >
                  Clear All Notifications
                </button>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  {notifications.map(n => (
                    <li
                      key={n._id}
                      style={{
                        marginBottom: '10px',
                        color: n.read ? '#888' : '#333',
                        backgroundColor: n.read ? 'rgba(255, 255, 255, 0.5)' : 'rgba(255, 255, 255, 0.8)',
                        borderRadius: '5px',
                        padding: '10px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                        transition: 'background-color 0.3s'
                      }}
                      onMouseOver={(e) => (e.currentTarget.style.backgroundColor = n.read ? 'rgba(255, 255, 255, 0.7)' : 'rgba(255, 255, 255, 1)')}
                      onMouseOut={(e) => (e.currentTarget.style.backgroundColor = n.read ? 'rgba(255, 255, 255, 0.5)' : 'rgba(255, 255, 255, 0.8)')}
                    >
                      <span style={{ textAlign: 'center', marginBottom: '5px' }}>
                        {renderMessage(n)}
                      </span>
                      <small style={{ color: '#666', display: 'block', marginBottom: '5px' }}>
                        {new Date(n.createdAt).toLocaleString()}
                      </small>
                      <div style={{ display: 'flex', gap: '10px' }}>
                        {!n.read && (
                          <button
                            onClick={() => markAsRead(n._id)}
                            style={{
                              fontSize: '12px',
                              background: '#1E88E5',
                              color: 'white',
                              border: 'none',
                              padding: '4px 10px',
                              borderRadius: '3px',
                              cursor: 'pointer',
                              transition: 'background-color 0.3s'
                            }}
                            onMouseOver={(e) => (e.target.style.backgroundColor = '#1976D2')}
                            onMouseOut={(e) => (e.target.style.backgroundColor = '#1E88E5')}
                          >
                            Mark Read
                          </button>
                        )}
                        <button
                          onClick={() => removeNotification(n._id)}
                          style={{
                            fontSize: '12px',
                            background: '#EF5350',
                            color: 'white',
                            border: 'none',
                            padding: '4px 10px',
                            borderRadius: '3px',
                            cursor: 'pointer',
                            transition: 'background-color 0.3s'
                          }}
                          onMouseOver={(e) => (e.target.style.backgroundColor = '#F44336')}
                          onMouseOut={(e) => (e.target.style.backgroundColor = '#EF5350')}
                        >
                          Remove
                        </button>
                      </div>
                    </li>
                  ))}
                </ul>
              </>
            ) : (
              <p style={{ margin: 0, color: '#333', fontSize: '14px', padding: '20px' }}>
                No notifications yet!
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default Notifications;